import * as style from './style.css';
import { IReviewStats } from '../../../../types/layouts/reviewStat';
import { Responsive, UIHeading2, UIHeading5, UIText1, UIText2 } from '@cian/ui-kit';
import { IconToggleStarOn12 } from '@cian/ui-kit-design-tokens/icons';
import { useMemo } from 'react';
import type * as React from 'react';
import { trackCardJkLinkClick } from '../../../../utils/tracking/trackCardJkLinkClick';

interface IHeaderProps {
  title: string;
  url: string;
  subtitle: string;
  rating: IReviewStats;
}

export const Header = ({ title, rating, subtitle, url }: IHeaderProps): React.JSX.Element => {
  const ratingRate = useMemo(() => {
    return String(rating.totalRate).replace('.', ',');
  }, [rating]);

  return (
    <div className={style['container']}>
      <Responsive desktop>
        <UIHeading2 color="text-main-default">
          <a href={url} target="_blank" className={style['link']} rel="noreferrer" onClick={trackCardJkLinkClick}>
            {title}
          </a>
        </UIHeading2>
        <UIHeading5>{subtitle}</UIHeading5>
      </Responsive>

      <Responsive phone tablet>
        <div>
          <UIText1 color="text-main-default">
            <a href={url} target="_blank" className={style['link']} rel="noreferrer" onClick={trackCardJkLinkClick}>
              {title}
            </a>
          </UIText1>
          <UIText2 color="gray60_100">{subtitle}</UIText2>
        </div>
      </Responsive>

      <Responsive desktop>
        <div className={style['rating']}>
          <div className={style['rating-star']}>
            <IconToggleStarOn12 color="decorative-orange" />
            <UIHeading5 color="decorative-orange">{ratingRate}</UIHeading5>
          </div>
          <UIText2 color="text-secondary-default">{rating.reviewCountText}</UIText2>
        </div>
      </Responsive>
    </div>
  );
};
